export default __webpack_public_path__ + "static/media/checkmark.058e3f5c.svg";